import { CommonModule } from '@angular/common';
import { inject, NgModule } from '@angular/core';

import { FeatureGuardModule } from '@recruitee/feature-guard';
import { I18nModule } from '@recruitee/i18n';
import {
  ButtonComponent,
  DividerModule,
  DropdownModule,
  EmptyStateModule,
  HeadingModule,
  IconComponent,
  RtUICoreOverlayModule,
} from '@recruitee/user-interface';

import { IntegrationsMailboxLinkInsertedActionToken } from '../integrations-mailbox-link-inserted-action-token';
import { ManageSchedulerLinkDialogComponentToken } from '../manage-scheduler-link-dialog-injection-token';
import { RedactorInsertsButtonComponent } from './redactor-inserts-button/redactor-inserts-button.component';
import { RedactorInsertsDropdownComponent } from './redactor-inserts-button/redactor-inserts-dropdown/redactor-inserts-dropdown.component';
import { RedactorInsertsEmailTemplatesComponent } from './redactor-inserts-button/redactor-inserts-email-templates/redactor-inserts-email-templates.component';
import { RedactorInsertsGdprComponent } from './redactor-inserts-button/redactor-inserts-gdpr/redactor-inserts-gdpr.component';
import { RedactorInsertsIntegrationsKununuComponent } from './redactor-inserts-button/redactor-inserts-integrations-kununu/redactor-inserts-integrations-kununu.component';
import { RedactorInsertsQuestionnairesComponent } from './redactor-inserts-button/redactor-inserts-questionnaires/redactor-inserts-questionnaires.component';
import { RedactorInsertsSchedulerComponent } from './redactor-inserts-button/redactor-inserts-scheduler/redactor-inserts-scheduler.component';
import { RedactorInsertsItemModule } from './redactor-inserts-item.module';

@NgModule({
  imports: [
    CommonModule,
    ButtonComponent,
    IconComponent,
    RtUICoreOverlayModule,
    DropdownModule,
    DividerModule,
    HeadingModule,
    EmptyStateModule,
    FeatureGuardModule,
    I18nModule,
    RedactorInsertsItemModule,
    RedactorInsertsSchedulerComponent,
  ],
  declarations: [
    RedactorInsertsButtonComponent,
    RedactorInsertsEmailTemplatesComponent,
    RedactorInsertsQuestionnairesComponent,
    RedactorInsertsGdprComponent,
    RedactorInsertsDropdownComponent,
    RedactorInsertsIntegrationsKununuComponent,
  ],
  exports: [
    RedactorInsertsButtonComponent,
    FeatureGuardModule,
    RedactorInsertsButtonComponent,
    RedactorInsertsEmailTemplatesComponent,
    RedactorInsertsQuestionnairesComponent,
    RedactorInsertsGdprComponent,
    RedactorInsertsDropdownComponent,
    RedactorInsertsIntegrationsKununuComponent,
  ],
})
export class RtRedactorInsertsSharedModule {
  constructor() {
    // checks tokens early that so errors will be thrown during bootstrap, not when token is actually used
    inject(ManageSchedulerLinkDialogComponentToken);
    inject(IntegrationsMailboxLinkInsertedActionToken);
  }
}
